/**
 * Shared error handling utilities for voucher feature
 * Extracted to eliminate code duplication between composables and components
 */
export const useVoucherErrorHandling = () => {
  const checkErrorMessageForCartState = (errorMessage) => {
    if (!errorMessage) {
      return false
    }
    const lowerMessage = errorMessage.toLowerCase()
    return lowerMessage.includes('cart is not in active state') ||
      lowerMessage.includes('cart is not active')
  }

  const extractActionError = (errorData) => {
    if (!errorData?.actionErrors || !errorData.actionErrors.length) {
      return null
    }
    return errorData.actionErrors[0]
  }

  const getTopLevelErrorMessage = (errorData) =>
    errorData?.message || errorData?.actionMessage || ''

  const getActionErrorMessage = (errorData) => {
    const actionError = extractActionError(errorData)
    return actionError?.message || ''
  }

  const hasCartStateErrorMessage = (errorData) => {
    if (!errorData) {
      return false
    }

    const topLevelMessage = getTopLevelErrorMessage(errorData)
    if (checkErrorMessageForCartState(topLevelMessage)) {
      return true
    }

    const actionErrorMessage = getActionErrorMessage(errorData)
    return checkErrorMessageForCartState(actionErrorMessage)
  }

  const isInvalidOperation = (actionError) => {
    return actionError?.code === 'InvalidOperation'
  }

  const getErrorData = (error) => error?.response?.data
  const hasCartStateError = (errorData) => {
    if (!errorData) {
      return false
    }
    const actionError = extractActionError(errorData)
    return hasCartStateErrorMessage(errorData) || isInvalidOperation(actionError)
  }

  const isCartStateError = (error) => hasCartStateError(getErrorData(error))

  const isCartStateErrorInResponse = (data) => {
    if (!data) {
      return false
    }
    const actionError = extractActionError(data)
    const errorMessage = data.message || actionError?.message || ''
    return checkErrorMessageForCartState(errorMessage) || isInvalidOperation(actionError)
  }

  const getErrorMessage = (error) => {
    if (isCartStateError(error)) {
      return 'Indkøbskurven er ikke længere aktiv. Prøv venligst igen.'
    }

    const errorData = error?.response?.data
    const actionError = extractActionError(errorData)

    if (actionError?.notificationMessage) {
      return actionError.notificationMessage
    }

    if (errorData?.actionMessage) {
      return errorData.actionMessage
    }

    return 'Ugyldig rabatkode eller koden kan ikke anvendes'
  }

  return {
    checkErrorMessageForCartState,
    hasCartStateErrorMessage,
    isCartStateError,
    isCartStateErrorInResponse,
    getErrorMessage
  }
}
